<template>
  <div class="main-content berita">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Tips & Trik Kesehatan</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="fasilitas-containter">
      <div class="container">
        <div class="section-title text-center">
          <div class="row">
            <div class="col-md-12">
              <h2 class="text-uppercase mt-0 line-height-1">Ragam Tips & Trik Kesehatan</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="news-container">
      <div class="container mb-30 pt-30 pb-30">
        <div class="row multi-row-clearfix">
          <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
          <div
            v-else-if="getArticlesContent(articles).length < 1"
            class="col-lg-12 alert alert-danger"
          >No data</div>
          <div v-else class="blog-posts">
            <div class="col-md-12">
              <div class="list-dashed">
                <article
                  :key="'article-' + item.id"
                  v-for="item in getArticlesContent(articles)"
                  class="post clearfix mb-30 pb-30"
                >
                  <div class="row">
                    <div class="col-lg-5 col-md-12">
                      <div class="entry-header">
                        <div class="post-thumb">
                          <img
                            class="img-responsive img-fullwidth"
                            v-bind:src="(item.image == null || item.image == '-' || item.image == '') ? 'http://www.sttibontang.ac.id/asset/img_playlist/no-image.jpg' : item.image"
                            alt
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-7 col-md-12">
                      <div class="entry-content mt-0 mt-md-20">
                        <a href="#">
                          <h4 class="entry-title mt-0 pt-0">{{ item.title }}</h4>
                        </a>
                        <ul class="list-inline mb-20 mt-10">
                          <li>
                            posted by
                            <a href="#" class="text-theme-colored">{{ item.user_admin }}</a>
                          </li>
                          <li class="separator">|</li>
                          <li>
                            <span class="text-theme-colored">{{ item.created_at }}</span>
                          </li>
                        </ul>
                        <p class="mb-30">{{ item.description }}</p>
                        <b-link
                          class="btn btn-flat btn-theme-colored btn-circled mt-15 text-theme-color-2"
                          :to="{ 
					                        	name: 'berita-detail', 
					                        	params: { 
					                        		slug: item.slug,
					                        	} 
					                        }"
                        >Read more</b-link>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ACTION_SET_ARTICLES } from "../store/repo/pages";
export default {
  data() {
    return {
      show_loading: false,
      page: 1,
      type: "tips-trick",
    };
  },
  mounted() {
    this.$store.dispatch(ACTION_SET_ARTICLES, {
      page: this.page,
      type: this.type,
    });
  },
  methods: {
    getArticlesContent(data) {
      return data;
    },
  },
  computed: {
    articles() {
      return this.$store.getters.getArticles.data == undefined
        ? []
        : this.$store.getters.getArticles.data;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/TipsTrik.vue